<template>
    <div>
        <el-form
            :inline="true"
            :model="searchlist"
            class="demo-form-inline"
            size="mini"
        >
            <el-form-item label="姓名:" style="margin: 0 30 0 0">
                <el-input
                    v-model="searchlist.name"
                    placeholder="请输入姓名"
                ></el-input>
            </el-form-item>
            <el-form-item label="手机号:" style="margin: 0 30 0 0">
                <el-input
                    v-model="searchlist.numberId"
                    placeholder="请输入手机号"
                ></el-input>
            </el-form-item>
            <el-form-item style="margin: 0 0 0 100px">
                <el-button size="mini" @click="searchlistdata">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f8fafa' }"
            border
            align="center"
            current-row-key
            highlight-current-row
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column
                align="center"
                prop="userCode"
                label="编号"
            ></el-table-column>
            <el-table-column
                align="center"
                prop="name"
                label="姓名"
            ></el-table-column>
            <el-table-column
                align="center"
                prop="gendar"
                label="性别"
            ></el-table-column>
            <el-table-column
                align="center"
                prop="mobile"
                label="手机号"
            ></el-table-column>
            <el-table-column
                align="center"
                prop="loginFlag"
                label="状态"
            ></el-table-column>
        </el-table>
        <div class="boontbtn">
            <el-button
                type="primary"
                size="small"
                @click="createData"
                style="margin: 0 30px"
                >保存</el-button
            >
        </div>
    </div>
</template>

<script>
import request from "../../../utils/request.js"
export default {
    name: "ViewUser",
    props: [],
    data() {
        return {
            searchlist: {},
            tableData: [],
            multipleSelection: [],
        }
    },
    methods: {
        //条件查询
        searchlistdata() {
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            this.multipleSelection = []
            this.searchlist.pageNo = 1
            this.searchlist.pageSize = 20
            let params = JSON.stringify(this.searchlist)
            // console.log(params)
            var res = await request({
                url: "user/info/findUserList",
                method: "POST",
                data: params,
            })
            // console.log(res)
            if (res.code == 200) {
                this.tableData = res.content.list
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常：",
                    type: "error",
                })
            }
        },
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val
        },
        //封装数据
        createData() {
            //func: 是父组件指定的传数据绑定的函数
            this.$emit("func", this.multipleSelection)
        },
    },
    mounted() {
        this.getPageDatas()
    },
}
</script>
